// extracted by css-extract-rspack-plugin
export default {"sidebarPaddingLayout":"EIQYf0"};